import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

// Bármely oldalt körbevéve csak bejelentkezett (regisztrált) felhasználóknak
// engedi meg a hozzáférést. Ha nincs bejelentkezve, a /belepes oldalra irányít.
//
// Használat App.jsx-ben:
//   <Route path="/temakork" element={<VedettUtvonal><Temakork/></VedettUtvonal>} />
//
// A Fogalmak.jsx route-ját NE csomagold be ebbe — az mindenkinek elérhető marad.

function VedettUtvonal({ children }) {
  const [felhasznalo, setFelhasznalo] = useState(undefined); // undefined = tölt, null = nincs bejelentkezve

  useEffect(() => {
    const leiratkozas = onAuthStateChanged(auth, (user) => {
      setFelhasznalo(user);
    });
    return () => leiratkozas();
  }, []);

  if (felhasznalo === undefined) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '60vh', fontSize: '18px', fontWeight: 700, color: '#1a73e8',
      }}>
        ⏳ Betöltés...
      </div>
    );
  }

  if (!felhasznalo) {
    return <Navigate to="/belepes" replace />;
  }

  return children;
}

export default VedettUtvonal;